import React, { FC, useState } from "react";
import classes from "./InputComment.module.scss";
import { Edit } from "@mui/icons-material";

import { Modal, TextField, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { Dirary } from "../../../types/dirary";
import DiaryList from "../../pages/list/DiaryList";
import { Buttons } from "../../uikit/atoms/buttons/Buttons";

//保存
import SaveIcon from "@mui/icons-material/Save";
//キャンセル
import CancelIcon from "@mui/icons-material/Cancel";

type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  isReadOnly: boolean;
  comment: string;
};

const ViewComment: FC<Props> = (props) => {
  const { comment, isReadOnly, setIsShow } = props;
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  const handleSaveButtonClick = () => {
    setOpen(false);
    setIsShow(false);
  };
  const handleCancelButtonClick = () => {
    setOpen(false);
    setIsShow(false);
  };
  const handleOnChangeComment = (e: React.ChangeEvent<HTMLInputElement>) => {};
  const style = () => {
    let styles = {
      backgroundColor: theme.palette.backColor.dark,
      borderRadius: "5px",
      fontSize: "14px",
      padding: "0 2px",
      width: "280px",
      // "@media (max-width: 600px)": {
      //   fontSize: "14px", // フォントサイズを14pxに設定
      //   width: "120px",
      // },

      "&&&": {
        padding: "0 2px",
      },
      "& .MuiInputBase-root": {
        height: "200px",
        alignItems: "flex-start",
        overflowY: "auto",
      },
      "& .MuiInputBase-input": {
        color: theme.palette.foreColor.light, // 入力文字の色
        fontSize: "16px",
        padding: "0 2px",
        height: "180px",
        overflowY: "auto",

        // "@media (max-width: 600px)": {
        //   fontSize: "10px", // フォントサイズを14pxに設定
        // },
      },
      //スピンボタンの無効化-効いていない
      ':global(input[type="number"]::-webkit-outer-spin-button)': {
        WebkitAppearance: "none",
        margin: 0,
      },
      ':global(input[type="number"]::-webkit-inner-spin-button)': {
        WebkitAppearance: "none",
        margin: 0,
      },

      "& label": {
        color: theme.palette.foreColor.main, // 通常時のラベル色
        //backgroundColor:"white"
        fontSize: "14px",
        "@media (max-width: 600px)": {
          fontSize: "12px", // フォントサイズを14pxに設定
        },
      },
      "& label.Mui-focused": {
        color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
      },

      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
        },
        "& .MuiInputBase-root": {
          padding: "0 2px",
        },
        "&.css-lc33rk-MuiInputBase-root-MuiOutlinedInput-root": {
          padding: "2px 2px",
          minHeight: "60px",
        },
      },
    };

    return styles;
  };
  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: "none",
        "&:focus-visible": {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div className={classes.formContainer}>
        <div className={classes.header}>
          <p>コメント入力</p>
          <div className={classes.saveButtons}>
            <div>
              <Buttons
                disabled={isReadOnly}
                onClick={handleSaveButtonClick}
                caption={"保存"}
                icon={<SaveIcon />}
                width={24}
                height={24}
                fontSize={24}
              />
            </div>
            <div>
              <Buttons
                disabled={false}
                onClick={handleCancelButtonClick}
                caption={"キャンセル"}
                icon={<CancelIcon />}
                width={24}
                height={24}
                fontSize={24}
              />
            </div>
          </div>
        </div>
        <div className={classes.hr}></div>
        <div className={classes.main}>
          <TextField
            label={""}
            variant="outlined"
            value={comment}
            InputProps={{ readOnly: isReadOnly }}
            InputLabelProps={{ shrink: true }}
            sx={style()}
            multiline={true}
            onChange={handleOnChangeComment}
            inputProps={{ maxLength: 100 }}
            // helperText={errorWorkerName.text}
            // disabled={isDisabled}
            // error={errorWorkerName.isShow}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ViewComment;
